import type { RouteObject } from 'react-router-dom'

import { Component as Profile } from '@/modules/profile/pages/Profile'
import { Component as Settings } from '@/modules/profile/pages/Settings'
import { ProfileRoutePathsEnum } from '@/modules/profile/routes/profileRouteConfig.types'

export const PROFILE_ROUTES: RouteObject[] = [
  {
    element: <Profile />,
    path: ProfileRoutePathsEnum.PROFILE,
  },
  {
    element: <Settings />,
    path: ProfileRoutePathsEnum.SETTINGS,
  },
]
